import React from 'react';

import { DotCircleRegularIcon } from '../../../shared/icons/icons';

import styles from './my-location-marker.scss';

function MyLocationMarker() {
  return <DotCircleRegularIcon className={styles['icon']} />;
}

export default React.memo(MyLocationMarker);
